import { render, staticRenderFns } from "./MenuPc.vue?vue&type=template&id=7831d64c&"
import script from "./MenuPc.vue?vue&type=script&lang=js&"
export * from "./MenuPc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports